import React from 'react';
import { NavigationHelperContext } from './NavigationHelperContext';

export const withNavigationHelper = (Component) => (props) =>
    (
        <NavigationHelperContext.Consumer>
            {(context) => <Component {...props} {...context} />}
        </NavigationHelperContext.Consumer>
    );
